// extracted by mini-css-extract-plugin
export var article = "Tips-module--article--2509a";
export var articlesHidden = "Tips-module--articlesHidden--cc4e7";
export var buttonClean = "Tips-module--buttonClean--a01d9";
export var container = "Tips-module--container--3afb9";
export var fromHidden = "Tips-module--fromHidden--c12c7";
export var isHidden = "Tips-module--isHidden--f550e";
export var listClean = "Tips-module--listClean--e2121";
export var tip = "Tips-module--tip--8e004";
export var tipsArticlesList = "Tips-module--tipsArticlesList--b3054";
export var tipsBody = "Tips-module--tipsBody--c2dee";
export var tipsBodyHeadingText = "Tips-module--tipsBodyHeadingText--04393";
export var tipsContainer = "Tips-module--tipsContainer--6e944";
export var tipsNav = "Tips-module--tipsNav--d7d5b";
export var tipsNavHeading = "Tips-module--tipsNavHeading--7765d";
export var tipsNavHeadingText = "Tips-module--tipsNavHeadingText--30564";
export var tipsNavList = "Tips-module--tipsNavList--d21e2";
export var toHidden = "Tips-module--toHidden--72534";
export var toggleButton = "Tips-module--toggleButton--b43d5";
export var toggleButtonContainer = "Tips-module--toggleButtonContainer--812b6";